// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"Tooltip_scroll-black__68Prt","tooltip":"Tooltip_tooltip__KH6mE","question-icon":"Tooltip_question-icon__UBWje"};